import React from "react";
import { Col, FormFeedback, Input, InputGroup, Label } from "reactstrap";
import Select from "react-select";
import classNames from "classnames";
import NibbleInputImage from "./NibbleInputImage";
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import { createFilter } from "react-select/dist/react-select.cjs.prod";
import dayjs from "dayjs";
import * as _ from "lodash";

const NibbleInput = ({
  md = 6,
  label = "label",
  fieldName = "field_name",
  validation,
  fieldType = "text",
  placeHolder = "",
  selectItems = [],
  selectIsClearable = true,
  selectOptionValue = (option) => option?.id,
  selectOptionLabel = (option) => `${option?.name}`,
  selectIsSearchable = true,
  selectStringify = null,
  postFileFunction = () => {},
  itemFile = null,
  maxLength = null,
  readOnly = false,
  disabled = false,
  format = null,
  accept = null,
  radioOptions = [],
  defaultRadioChecked = "",
  filterOption = (option) => `${option.label}`, // JUST CAN USE ID and LABEL attributes DEFAULT IS   option => "".concat(option.label, " ").concat(option.value),
}) => {
  const fieldValue = _.get(validation.values, fieldName, "");
  const fieldError = _.get(validation.errors, fieldName, "");
  const fieldTouched = _.get(validation.touched, fieldName, "");
  const isInvalidField = fieldError && fieldTouched;

  if (fieldType == "image")
    return (
      <NibbleInputImage
        md={md}
        label={label}
        fieldName={fieldName}
        validation={validation}
        postFileFunction={postFileFunction}
        itemFile={itemFile}
      />
    );

  if (fieldType == "textarea")
    return (
      <Col className="mt-2" md={md}>
        <Label className="form-label">{label}</Label>
        <Input
          type="textarea"
          className="form-control"
          name={fieldName}
          maxLength={255}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values[fieldName]}
          invalid={
            validation.touched[fieldName] && validation.errors[fieldName]
          }
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );

  if (fieldType == "select")
    return (
      <Col className="mt-2" md={md}>
        <Label className="form-label">{label}</Label>
        <Select
          placeholder="Seleccionar..."
          className={classNames({
            "select-control": true,
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          value={
            selectItems.filter((e) => {
              return selectOptionValue(e) == validation.values[fieldName];
            })[0] ?? null
          }
          stringify={selectStringify ?? selectOptionLabel}
          isClearable={selectIsClearable}
          isSearchable={selectIsSearchable}
          getOptionLabel={selectOptionLabel}
          getOptionValue={selectOptionValue}
          name={fieldName}
          options={selectItems}
          onChange={(option, meta) => {
            validation.setFieldValue(
              fieldName,
              selectOptionValue(option) ?? null,
              true
            );
          }}
          filterOption={
            createFilter({
              matchFrom: 'any',
              stringify: filterOption,
            })
          }
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );

  if (fieldType == "time")
    return (
      <Col className="mt-2 form-group" md={md}>
        <Label className="form-label">{label}</Label>

        <InputGroup
          className={classNames({
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
        >
          <Flatpickr
            value={validation.values[fieldName] ?? ""}
            className={classNames({
              "form-control": true,
              "d-block": true,
              "is-invalid":
                validation.touched[fieldName] && validation.errors[fieldName],
            })}
            placeholder="Seleccionar..."
            options={{
              enableTime: true,
              noCalendar: true,
              dateFormat: "H:i",
              time_24hr: true,
              minuteIncrement: 1,
            }}
            onChange={([date]) => {
              console.log(date);
              validation.setFieldValue(
                fieldName,
                dayjs(date).format("HH:mm"),
                true
              );
            }}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="mdi mdi-clock-outline" />
            </span>
          </div>
        </InputGroup>
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );

  if (fieldType == "file")
    return (
      <Col className="mt-2" md={md}>
        <Label className="form-label">{label}</Label>
        <Input
          className="form-control"
          placeholder={placeHolder}
          name={fieldName}
          type={fieldType}
          onChange={(event) => {
            if (event.currentTarget.files) {
              validation.setFieldValue(fieldName, event.currentTarget.files[0]);
            }
          }}
          onBlur={validation.handleBlur}
          invalid={
            validation.touched[fieldName] && validation.errors[fieldName]
          }
          maxLength={maxLength}
          readOnly={readOnly}
          disabled={disabled}
          format={format}
          accept={fieldType == "file" ? accept ?? "*/*" : null}
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );

  if (fieldType == "radios")
    return (
      <Col className="mt-2" md={md}>
        <Label className="form-label">{label}</Label>
        {radioOptions.map((radio) => (
          <div key={radio.label} className="form-check mb-1">
            <Input
              className="form-check-input"
              type="radio"
              name="tipo"
              id={radio.label}
              value={radio.value}
              defaultChecked={defaultRadioChecked === radio.value}
              onClick={({ target }) => {
                validation.setFieldValue(fieldName, target.value);
              }}
              invalid={
                validation.touched[fieldName] && validation.errors[fieldName]
              }
            />
            <label className="form-check-label" htmlFor={radio.label}>
              {radio.label}
            </label>
          </div>
        ))}
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );

  return (
    <Col className="mt-2" md={md}>
      <Label className="form-label">{label}</Label>
      <Input
        className="form-control"
        placeholder={placeHolder}
        name={fieldName}
        type={fieldType}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        value={fieldValue}
        invalid={isInvalidField}
        maxLength={maxLength}
        readOnly={readOnly}
        disabled={disabled}
        format={format}
      />
      <FormFeedback type="invalid">{fieldError}</FormFeedback>
    </Col>
  );
};

export default NibbleInput;
